import React from "react";
import {
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
  Button,
  CardActionArea,
} from "@mui/material";
import project1 from "../image/health.png";
const SingleProject = ({ project }) => {
  return (
    <div className="col-md-4 col-10 mx-auto  my-2">
      <Card sx={{ maxWidth: 345 }}>
        <CardActionArea>
          <CardMedia
            component="img"
            height="240"
            image={project.pic}
            alt="green iguana"
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              {project.title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {project.text}
            </Typography>
          </CardContent>
          <CardActions>
            <Button size="small">Source</Button>
            <Button
              component="a"
              href={project.live}
              target="_blank"
              size="small"
            >
              Live
            </Button>
          </CardActions>
        </CardActionArea>
      </Card>
    </div>
  );
};

export default SingleProject;
